import {Component, forwardRef, OnDestroy} from '@angular/core';
import {ISimpleSelectableDataList} from "../../../../model/interface/simple-selectable-data.model.interface";
import {FormBuilder, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators} from "@angular/forms";
import {AbstractControlComponent} from "../../../../abstract-control-value-accessor/abstract-control.component";
import {ObjectListHelper} from "../../../../helper/object-list.helper";
import {map, mergeMap} from "rxjs/operators";
import {Base64FileHelper} from "../../../../helper/base64-file.helper";
import {partition, Subscription} from "rxjs";

@Component({
  selector: 'app-attachment-select',
  templateUrl: './parcel-attachment-select.component.html',
  styleUrls: ['./parcel-attachment-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ParcelAttachmentSelectComponent),
      multi: true,
    },
  ],
})
export class ParcelAttachmentSelectComponent extends AbstractControlComponent implements OnDestroy {

  formGroup: FormGroup;

  TYPES = ObjectListHelper.fromArray([
    {
      value: "auto",
      label: 'Generowany automatycznie',
      tooltip: 'Upewnij się, że dla tego zlecającego istnieje mechanizm automatycznego generowania wybranego dokumentu.'
    },
    {
      value: 'provided',
      label: 'Przekazywany',
      tooltip: 'Do przesyłki załączony zostanie przesłany przez Ciebie dokument.'
    },
    {
      value: 'manual',
      label: 'Załączany ręcznie',
      tooltip: 'Należy umieścić fizyczny list.'
    }
  ]) as ISimpleSelectableDataList;

  get hasFile() {
    return this.formGroup.get('file') !== null;
  }

  private subscriptions: Subscription[] = [];
  constructor(private formBuilder: FormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      type: null
    });
    this.formGroup.valueChanges.subscribe(_ => console.log(this.formGroup.value))
  }

  onSelect(type: string) {
    if (type === 'provided') {
      this.formGroup.addControl('file', new FormControl(null, Validators.required))
    } else if (this.hasFile) {
      this.formGroup.removeControl('file')
    }
  }

  registerOnChange(fn: any): void {
    const [withFile$, withoutFile$] = partition(this.formGroup.valueChanges, (v, i) => !!v.file);

    this.subscriptions.push(
        withFile$.pipe(
            mergeMap(v => {
              return Base64FileHelper.fromFile(v.file)
                  .pipe(
                      map(base64 => {
                        return {
                          file: base64,
                          type: v.type
                        }
                      })
                  )
            })
        ).subscribe(fn),
      withoutFile$.subscribe(fn)
    );

  }

  writeValue(obj: any): void {
    if (obj) {
      this.formGroup.setValue(obj);
    } else {
      this.formGroup.reset();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
